// ============================================
// MovingAverageSettingsMenu.jsx — settings for one Moving Average overlay.
// Built only from the shared shell (menu/ChartMenu) and its primitives.
// Every control applies immediately (no Apply); Length is a debounced
// MenuNumber (~200ms after typing stops, at once on blur / Enter / close).
//
// config: one entry of the chart's MA config array
//   { id, on, type: 'sma'|'ema', length, color, weight }
// onUpdate(patch) merges into that entry.
// ============================================
import ChartMenu, { MenuRow, MenuSelect, MenuNumber, MenuSwatch, MenuWeight, MenuToggle, MenuDivider, MenuIndex } from './menu/ChartMenu'
import { MA_TYPES, MA_LEN_MIN, MA_LEN_MAX } from '../utils/movingAverage'

export default function MovingAverageSettingsMenu({ show, x, y, openLeft, config, onUpdate, onClose }) {
  if (!show || !config) return null
  return (
    <ChartMenu anchor={{ x, y }} openLeft={openLeft} onClose={onClose}>
      <MenuRow label="MA">
        <MenuToggle on={config.on} onChange={(v) => onUpdate({ on: v })} title="Show / hide this moving average">
          {config.on ? '✓ ON' : '○ OFF'}
        </MenuToggle>
        <MenuDivider />
        <MenuSelect value={config.type} options={MA_TYPES} title="Simple or exponential"
          onChange={(v) => onUpdate({ type: v })} />
        <MenuDivider />
        <MenuNumber label="LEN" value={config.length} min={MA_LEN_MIN} max={MA_LEN_MAX} clampMax width={44}
          title={`Bars averaged (${MA_LEN_MIN}–${MA_LEN_MAX})`}
          onCommit={(n) => onUpdate({ length: Math.max(MA_LEN_MIN, Math.min(MA_LEN_MAX, n)) })} />
      </MenuRow>
      <MenuRow label="Line">
        <MenuSwatch value={config.color} onChange={(c) => onUpdate({ color: c })} title="Line colour" />
        <MenuDivider />
        <MenuWeight value={config.weight} weights={[1, 2, 3, 4]} onChange={(w) => onUpdate({ weight: w })} />
      </MenuRow>
      <MenuIndex value={config.index} onChange={(v) => onUpdate({ index: v })} />
    </ChartMenu>
  )
}
